import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { ButtonDatepickerComponent } from "../../../shared/button-datepicker/button-datepicker.component";
import {
  CompanyAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  TripAttributes,
  VisitAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { DateHourPipe } from "app/pipes/formated-date.pipe";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CompanyService } from "../../configuration/company/company.service.service";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import * as L from "leaflet";
import { AgendaMapComponent } from "./agenda-map/agenda-map.component";
import { LoadCalculationModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/load-calculation-mode.enum";
import { MatMenuModule } from "@angular/material/menu";
import { statusERP } from "app/layout/export-overlay/tasks/core/processors/types/ave/ave-types";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { DateService } from "./agenda-view.service";
import VehicleAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity";
import { VechicleService } from "../../transport/vechicle/vehicle.service";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PrincipalScreenService } from "../principal-screen/principal-screen.service";
import { firstValueFrom } from "rxjs";
import { UserMasterService } from "../../routing/sub-routes/sub-route-collaborator/user_master.service";
import { TripService } from "../../reports/visits/visit-report/visit-report.service";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';

interface statusDocument {
  countDocument: number;
  notAllowedSync: number; // los que no tienen la variable statusERP
  notSynchronization: OrderStatusERPEnum;  // statusERP = OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR
  loadSynchronization: OrderStatusERPEnum; // statusERP = OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND
  synchronization: number;
}

interface IStatusRoute {
  countDocument: number;
  visitValid: number;
  visitNotValid: number;
}

@Component({
  selector: "app-agenda-view",
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatSortModule,
    DateHourPipe,
    MatCardModule,
    MonedaPipe,
    ReactiveFormsModule,
    MatIconModule,
    MatPaginatorModule,
    MatButtonModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatTableModule,
    AgendaMapComponent,
    MatTabsModule,
    ButtonDatepickerComponent,
  ],
  templateUrl: "./agenda-view.component.html",
  styleUrl: "./agenda-view.component.scss",
  animations: [
    trigger("expandCollapse", [
      state(
        "void",
        style({
          height: "0px",
          opacity: 0,
        })
      ),
      state(
        "*",
        style({
          height: "*",
          opacity: 1,
        })
      ),
      transition("void <=> *", animate("300ms ease-in-out")),
    ]),
  ],
})
export class AgendaViewComponent implements AfterViewInit {
  StatusEnum = StatusEnum
  OrderStatusERPEnum = OrderStatusERPEnum
  DocumentTypeEnum = DocumentTypeEnum
  
  currentUpdateTrip: TripAttributes | undefined;
  selectedHour = signal<string>("");

  timeSlots = Array.from({ length: 14 }, (_, i) => {
    const hour = i + 8;
    return `${hour.toString().padStart(2, "0")}:00`;
  });

  displayedColumns: string[] = [
    "expandable",
    // "circle",
    "shipTo",
    "document",
    "noSync",
    "toSync",
    "sync",
    // "price",
    // "loan",
  ];
  displayedColumnsShip: string[] = [
    "expandable",
    "status",
    "statusERP",
    "type",
    "class",
    "serial",
    "loan",
    "price",
  ];

  displayedColumnsMaterial: string[] = [
    "material",
    "quantity",
    "loan",
    "price",
  ];

  displayedColumnsVisits: string[] = ["pin", "shipTo", "visit", "duration"];
  // dataSource: any[] = [];
  dataSourceShip = new MatTableDataSource<OrderAttributes>([]);
  dataSourceMaterial = new MatTableDataSource<OrderDetailAttributes>([]);
  dataSourceVisit = new MatTableDataSource<VisitAttributes>([]);
  companyList: CompanyAttributes[] = [];
  vehicleList: VehicleAttributes[] = [];
  userMasterList: any[] = [];
  totalItems = 0;
  // search: string = "";
  pageSize = 5;
  pageIndex = 0;
  sortActive = null;
  sortDirection = "asc";

  currency: string = "";
  // searchQuery = "";
  selectedDetail: any | null = null;
  selectedShip: any | null = null;

  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });
  selectedVisits = [];
  public isVisibleDetailsDoc = false;
  public isFieldVisible = false;
  public isUserVisible = false;
  selectedVehicle: any = null; 
  selectedUser: any = null; 
  selectedDateStartTeoric: any = null;
  selectedDateEndTeoric: any = null;

  statusDocument: statusDocument = {
    countDocument: 0,
    notAllowedSync: 0, // los que no tienen la variable statusERP
    notSynchronization: 0,  // statusERP = OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR
    loadSynchronization: 0, // statusERP = OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND
    synchronization: 0, // statusERP OrderStatusERPEnum.ORDER_CREATED
  };
  routes = [];

  showMap: boolean = true;

  isExpanded: { [key: string]: boolean } = {};
  selectedDate = new Date();


  UserToControl = new FormControl("");


  //Responsable (ship to)
  shipToControl = new FormControl("");
  shipToList: any[] = [];
  shipToFilterList: any[] = [];
  shipToSelected: any = null;

  public dataSourceItemsRoutes: VisitAttributes[] = [];
  statusRoute: IStatusRoute = {
    visitNotValid: 0,
    visitValid: 0,
    countDocument: 0,
  };

  @Input() fetchAllWithCount: (
    pageSize: number,
    pageIndex: number,
    sortActive: any,
    selectedDate?: any
  ) => void;
  @Input() dataSource: any;
  @Input() search: any;
  @Input() pinnedTripIds: Set<number> = new Set();
  @Input() showOnlyPinned: boolean = false;

  @Output() openPinnedModal = new EventEmitter<void>();
  @Output() togglePinTrip = new EventEmitter<number>();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(AgendaMapComponent) mapComponent: AgendaMapComponent;
  constructor(
    private dateService: DateService,
    private companyService: CompanyService,
    private vehicleService: VechicleService,
    private readonly tripService: PrincipalScreenService,
    private snackBar: MatSnackBar,
    private readonly userMasterService: UserMasterService,
    private readonly visitService: TripService,
  ) {
    // this.selectedDate = new Date();
    this.selectedDate = this.dateService.getSelectedDate();
  }

  ngAfterViewInit(): void {
    this.fetchAllCompanies();
    this.fetchAllVehicle(); // Consulta: Por que no traen todos los vehiculos?
    this.setupPaginationAndSorting();
    this.shipToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.vehicleList = []; //al buscar se debe reiniciar
        this.fetchAllVehicle(value);
      });

      this.UserToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.userMasterList = []; //al buscar se debe reiniciar
        this.fetchAllUserMaster(value);
      });
  }

  /**
   * Handle pin/unpin trip event
   */
  onTogglePinTrip(tripId: number): void {
    this.togglePinTrip.emit(tripId);
  }

  /**
   * Handle open pinned trips modal event
   */
  onOpenPinnedModal(): void {
    this.openPinnedModal.emit();
  }

  /**
   * Check if a trip is pinned
   */
  isPinnedTrip(tripId: number): boolean {
    return this.pinnedTripIds.has(tripId);
  }

  /**
   * Sort routes by pinned status - pinned trips first
   */
  private sortRoutesByPinnedStatus(): void {
    if (this.routes && this.routes.length > 0) {
      this.routes = this.routes.sort((a, b) => {
        const aPinned = this.isPinnedTrip(a.id_viaje);
        const bPinned = this.isPinnedTrip(b.id_viaje);

        // Pinned trips go first
        if (aPinned && !bPinned) return -1;
        if (!aPinned && bPinned) return 1;

        // Keep original order for same type
        return 0;
      });
    }
  }

  private async fetchAllCompanies() {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private async fetchAllVehicle(search?) {
    this.vehicleService.findToComboBoxTrip(search ? search : '').subscribe({
      next: (res) => {
        this.vehicleList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener vehículos.","Cerrar",{ duration: 5000});
      },
    });
  }

    private async fetchAllUserMaster(search?): Promise<void> {
      try {
        const filter = {
          search: search,
        };
        const resUser: any = await firstValueFrom(
          this.userMasterService.findUserAvailable(filter)
        );
        this.userMasterList = resUser.data;

      } catch (err) {
        this.snackBar.open(err.error.message || "Error al obtener usuarios maestros.","Cerrar",{ duration: 5000});
      }
    }

  fetchVehicleToName = (shiptoId: string): string => {
    const foundShipTo = this.vehicleList.find(
      (shipTo) => shipTo._id.toString() === shiptoId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  fetchUserToName = (shiptoId: string): string => {
    const foundShipTo = this.userMasterList.find(
      (shipTo) => shipTo._id.toString() === shiptoId
    );
    if (foundShipTo) {
      return foundShipTo.user_login_username;
    }
    return "";
  };

  toggleExpand(id: number, route) {
    // Si el elemento está abierto, lo cerramos
    if (this.isExpanded[id]) {
      this.isExpanded[id] = false;
      this.isFieldVisible = false;
      this.isUserVisible = false;
    } else {
      // Si no está abierto, cerramos todos los demás y abrimos el seleccionado
      for (const key in this.isExpanded) {
        if (this.isExpanded.hasOwnProperty(key)) {
          this.isExpanded[key] = false;
        }
      }
      this.isFieldVisible = false;
      this.isUserVisible = false;
      this.isExpanded[id] = true;


      this.loadDataVisit(id, route);
    }
  }

  changeDate(days: number) {
    const newDate = new Date(this.selectedDate);
    newDate.setDate(newDate.getDate() + days);
    this.selectedDate = newDate;
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.fetchAllWithCount(
      this.pageSize,
      this.pageIndex,
      null,
      this.selectedDate
    );
  }

  onHoverActivityDay(time: any, index: any) {
    this.selectedHour.set(time);
  }

  onLeaveActivityDay() {
    this.selectedHour.set("");
  }

  onDateSelected(event: any) {
    this.selectedDate = event;

    this.dateService.setSelectedDate(this.selectedDate); // Guarda la nueva fecha seleccionada
  
    if (this.paginator) {
      this.pageIndex = this.paginator.pageIndex + 1;
    } else {
      this.pageIndex = 1;
    }
    this.fetchAllWithCount(
      this.pageSize,
      this.pageIndex,
      null,
      this.selectedDate
    );
    // this.findAllWithCount();
  }

  getRandomNumber(number: number) {
    return Math.floor(Math.random() * number);
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() =>
      this.fetchAllWithCount(
        this.pageSize,
        this.pageIndex,
        null,
        this.selectedDate
      )
    );
    // this.sort.sortChange.subscribe(() => {
    //   this.paginator.pageIndex = 0;
    //   this.findAllWithCount();
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["search"]) {
      if (this.search != undefined) {
        this.pageIndex = this.paginator.pageIndex + 1;
        this.fetchAllWithCount(
          this.pageSize,
          this.pageIndex,
          null,
          this.selectedDate
        );
      }
    }

    if (changes["dataSource"]) {
      if (this.dataSource) {
        const totalItemsFromPageInfo =
          this.dataSource.pageInfo?.[0]?.total ?? 0;
        this.dataSource = this.dataSource?.data ?? [];
        this.totalItems = totalItemsFromPageInfo;
        this.paginator.length = this.totalItems;
        this.transformData(this.dataSource);
      }
    }

    // Re-sort routes when pinned trips change
    if (changes["pinnedTripIds"]) {
      this.sortRoutesByPinnedStatus();
    }
  }

  // findAllWithCount(): void {
  //   this.range.valueChanges.subscribe((rangeValues) => {
  //     this.filter.dateini = rangeValues.start || this.filter.dateini;
  //     this.filter.dateend = rangeValues.end || this.filter.dateend;
  //   });
  //   const adjustedStart = new Date(this.filter.dateini);
  //   adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

  //   const adjustedEnd = new Date(this.filter.dateend);
  //   adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

  //   let date = {
  //     start: adjustedStart.toISOString(), // Convertir a UTC
  //     end: adjustedEnd.toISOString(), // Convertir a UTC
  //   };

  //   const adjustedSelectedDateStart = new Date(this.selectedDate);
  //   adjustedSelectedDateStart.setHours(0, 0, 0, 0); // 00:00:00.000

  //   const adjustedSelectedDateEnd = new Date(this.selectedDate);
  //   adjustedSelectedDateEnd.setHours(23, 59, 59, 999); // 23:59:59.999

  //   date.start = adjustedSelectedDateStart.toISOString();
  //   date.end = adjustedSelectedDateEnd.toISOString();

  //   const pageIndex = this.paginator.pageIndex + 1;
  //   // const sortField = this.getSortFieldByTrip();
  //   const sortDirection: "ASC" | "DESC" =
  //     this.sortDirection === "asc" ? "ASC" : "DESC";
  //   // const routeIds = this.routeMultiCtrl.value.map((sub: SubRouteAttributes) =>
  //   //   sub.id)
  //   this.tripService
  //     .findAllWithCountByTrip(
  //       {
  //         currentPage: pageIndex,
  //         limitPerPage: this.pageSize,
  //         search: this.search,
  //         sort: this.sortActive,
  //         sortDirection: sortDirection,
  //       },
  //       date,
  //       // routeIds
  //     )
  //     .subscribe((data) => {
  //       this.dataSource = data?.data?.[0]?.data ?? [];
  //       // this.onStops(this.dataSource.map(a=>a.visits)):
  //       this.transformData(this.dataSource);
  //       this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
  //       this.paginator.length = this.totalItems;
  //     });
  // }

  private getSortFieldByTrip(): keyof TripAttributes {
    const validSortFields: (keyof TripAttributes)[] = ["statusId"];
    return validSortFields.includes(this.sort.active as keyof TripAttributes)
      ? (this.sort.active as keyof TripAttributes)
      : "dateHourStart";
  }

  onButtonClick(id: string, route?) {
    if (this.isFieldVisible) {
      // Guardar el valor cuando el formulario está visible
      this.selectedVehicle = this.shipToControl.value;
      this.selectedDateStartTeoric = route.dateHourStartTeoric;
      this.selectedDateEndTeoric = route.dateHourEndTeoric;
      this.updateTrip(id.toString(), route);
    }else{
      this.shipToControl.reset(); 
    }
    this.isFieldVisible = !this.isFieldVisible; // Alternar la visibilidad
  }

  onEditTrip(route: any) {
    if (this.isUserVisible) {
      // Guardar el valor cuando el formulario está visible
      this.selectedUser = this.UserToControl.value;
      this.selectedDateStartTeoric = route.dateHourStartTeoric;
      this.selectedDateEndTeoric = route.dateHourEndTeoric;
      this.updateTrip(route.id.toString());
    }else{
      this.UserToControl.reset(); 
    }
    this.isUserVisible = !this.isUserVisible; // Alternar la visibilidad
  }

  // vehicle() {
  //   this.isVehicleVisible = !this.isVehicleVisible; // Alterna entre mostrar el campo y el texto
  // }


  updateTrip(id: string, route?): void {

        const updatedTrip: any = {
          ...this.currentUpdateTrip,
          vehicleId: this.selectedVehicle,
          masterUserId: route ? route?.user?._id : this.selectedUser,
          dateHourStartTeoric: this.selectedDateStartTeoric,
          dateHourEndTeoric: this.selectedDateEndTeoric,
        }
        
        // Solo agregamos si no son null
        if (updatedTrip.dateHourStartTeoric === null || updatedTrip.dateHourStartTeoric === undefined) {
          delete updatedTrip.dateHourStartTeoric;
        }

        if (updatedTrip.dateHourEndTeoric === null || updatedTrip.dateHourEndTeoric === undefined) {
          delete updatedTrip.dateHourEndTeoric;
        }

        if (updatedTrip.masterUserId !== null || updatedTrip.masterUserId === undefined) {
          delete updatedTrip.masterUserId;
        }

  
        this.tripService.update(id, updatedTrip).subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 3000,
              panelClass: ['mat-warn']
            });
            this.fetchAllWithCount(
              this.pageSize,
              this.pageIndex,
              null,
              this.selectedDate
            );
          this.shipToControl.reset();
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 7000 }
            );
          },
        });
    }

  onStops(visits: any) {
    const hoursArray = [];
    visits.forEach((visit) => {
      const dateTimeStart = new Date(visit.dateTimeStart);
      const hours = dateTimeStart.getUTCHours();
      if (hours <= 21) {
        //índice de acuerdo con la hora (8 AM = 0, 9 AM = 1, etc.)
        const index = hours - 8;
        hoursArray.push(index);
      }
    });
    return hoursArray;
  }

  processVisitsIndicator(visits: any[]): string {
    let totalVisits = 0;
    let performedVisits = 0;
    this.dataSourceVisit = new MatTableDataSource(visits);
    // Recorrer cada visita y extraemos los valores de visitsIndicator
    visits.forEach((visit) => {
      visit.duration = this.calculateTimeDifference(
        visit.dateTimeStart,
        visit.dateTimeEnd
      );
      const [total, performed] = visit.visitsIndicator
        .split("/")
        .map((num: string) => parseInt(num, 10));
      totalVisits += total;
      performedVisits += performed;
    });

    // formato 'total/visitado'
    return `${totalVisits}/${performedVisits}`;
  }

  private calculateTotalWeight(orders): string {
    let totalWeight = 0;
    let deliveredWeight = 0;
    let weightUnit = "LB";

    orders.forEach((order) => {
      const company = this.companyList.find(
        (company) => company.id === order.company.id
      );
      if (company) {
        const loadCalculationMode =
          company && company.loadCalculationMode
            ? company.loadCalculationMode
            : LoadCalculationModeEnum.BY_DIMENSIONS;
        order.detail.forEach((detailItem) => {
          if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
            if (detailItem.material && detailItem.material.dimensions) {
              // Si tiene dimensiones, hacemos el cálculo por dimensiones
              const grossWeight =
                detailItem.material.dimensions.grossWeight || 0;
              const baseQuantity = detailItem.baseQuantity || 0;
              const weightUnitFromDimensions =
                detailItem.material.dimensions.weightUnitOfMeasureCode || "LB";
              weightUnit = weightUnitFromDimensions;

              const weightedGrossWeight = grossWeight * baseQuantity;
              totalWeight += weightedGrossWeight;
              if (
                deliveredWeight === 0 &&
                (order.type.code === DocumentTypeEnum.FACTURA || order.type.code === DocumentTypeEnum.ENTREGA_SALIDA)
              ) {
                deliveredWeight = weightedGrossWeight;
              }
            }
          } else if (
            loadCalculationMode === LoadCalculationModeEnum.BY_BASE_QUANTITY
          ) {
            if (detailItem.material) {
              const baseQuantity = detailItem.baseQuantity || 0;
              const weightUnitFromBaseQuantity =
                detailItem.baseUnitOfMeasure?.code || "LB";
              weightUnit = weightUnitFromBaseQuantity;

              const weightedGrossWeight = baseQuantity;
              totalWeight += weightedGrossWeight;
              if (
                deliveredWeight === 0 &&
                (order.type.code === DocumentTypeEnum.FACTURA || order.type.code === DocumentTypeEnum.ENTREGA_SALIDA)
              ) {
                deliveredWeight = weightedGrossWeight;
              }
            }
          }
        });
      }
    });

    return `${totalWeight.toFixed(3)} ${weightUnit} / ${deliveredWeight.toFixed(3)} ${weightUnit}`;
  }

  private calculateTotalOrders(orders): string {
    let totalOrders = orders.length || 0;
    let deliveredOrders = 0;

    orders.forEach((order) => {
      if (order.type.code === DocumentTypeEnum.FACTURA || order.type.code === DocumentTypeEnum.ENTREGA_SALIDA) {
        deliveredOrders += 1;
      }
    });

    return `${totalOrders} / ${deliveredOrders}`;
  }

  transformData(trip: TripAttributes | any) {
    const routes = trip.map((route) => {
      this.currency = this.companyList.find(
        (company) => company.id === route.company.id
      )?.currencyBase?.code;
      const stopsv2 = this.onStops(route.visits);
      // const visitsSummary = this.processVisitsIndicator(route.visits);
      // const loan = this.calculateTotalWeight(route.orders);
      // const quantity = this.calculateTotalOrders(route.orders);
      //this.selectVisit(route.visits);
      // const statusDocument: statusDocument = this.calculateStatus(route.orders);
      const counts: { [key: number]: number } = {};

      stopsv2.forEach((stop) => {
        counts[stop] = (counts[stop] || 0) + 1;
      });

      const timeDifference = this.calculateTimeDifference(
        route.dateHourStart,
        route.dateHourEnd
      );
      
      return {
        id: route._id,
        id_viaje: route?.id,
        code: route?.subRoute?.externalKeys?.code,
        name: route.subRoute.name,
        stops: route?.stops,
        visits_2: stopsv2,
        randomNumber: counts,
        vehicle: route.vehicle,
        responsible: route?.orders?.map((a) => a.responsibleBusinessPartner)[0],
        ride: route.vehicle?.businessPartner,
        dateHourEnd: route.dateHourEnd,
        dateHourEndTeoric: route.dateHourEndTeoric,
        dateHourStartTeoric: route.dateHourStartTeoric,
        dateHourStart: route.dateHourStart,
        user: route.user.user_login.username,
        // visitsSummary: visitsSummary,
        // loan: loan,
        documents: this.groupOrders([
          ...(route.orders && route.orders.length > 0 ? route.orders : []),
          ...(route.payments && route.payments.length > 0
            ? route.payments
            : []),
        ]),
        timeDifference: timeDifference,
        // quantity: quantity,
        visits: route.visits,
        // statusDocument,
        statusTripId: route.statusTripId,
      };
    });

    // Sort routes: pinned trips first, then regular trips
    const sortedRoutes = routes.sort((a, b) => {
      const aPinned = this.isPinnedTrip(a.id_viaje);
      const bPinned = this.isPinnedTrip(b.id_viaje);

      // Pinned trips go first
      if (aPinned && !bPinned) return -1;
      if (!aPinned && bPinned) return 1;

      // Keep original order for same type
      return 0;
    });

    this.routes = sortedRoutes;
    // this.calculateStatus(
    //   routes
    //     .map(route =>
    //       route.documents
    //         .map(doc => doc.ordersByTypeAndSerial)
    //     )
    //     .flat(2)
    // );
    return sortedRoutes;
  }

  convertTimeToHour(time: string): number {
    const hour = parseInt(time.split(":")[0], 10);
    return hour - 8;
  }

  calculateTimeDifference(dateStart: string, dateEnd: string): string {
    const startDate = new Date(dateStart);
    const endDate = new Date(dateEnd);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return "00:00";
    }

    const diffInMs = endDate.getTime() - startDate.getTime();

    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

    // Formatear la diferencia como "HH:MM:SS"
    return `${hours} h ${minutes} m`;
  }

  toggleRow(detail: any): void {
    if (
      this.selectedDetail &&
      (this.selectedDetail.code === detail.id ||
        this.selectedDetail.id === detail.id)
    ) {
      this.selectedDetail = null;
    } else {
      this.selectedDetail = detail;
      this.onFilterDetail(detail);
    }
  }

  toggleShip(detail: any): void {
    if (this.selectedShip && this.selectedShip.serial === detail.serial) {
      this.selectedShip = null;
    } else {
      this.selectedShip = detail;
      this.onFilterMaterial(detail);
    }
  }

  onFilterDetail(order?: any) {
    this.dataSourceShip.data = [];
    this.dataSourceShip.data = order.ordersByTypeAndSerial;
  }

  onFilterMaterial(order?: any) {
    this.dataSourceMaterial.data = [];
    this.dataSourceMaterial.data = order.items;
  }

  // Método para alternar la visibilidad del mapa
  toggleMapVisibility() {
    this.showMap = !this.showMap;
  }

  openMapInPopup() {
    // Abre el mapa en el popup
    const popup = window.open("", "_blank", "width=800,height=600");

    // Verifica si la ventana se abrió correctamente
    if (popup) {
      // Marca que el popup está abierto, lo que oculta el mapa en el componente principal
      this.showMap = false;

      // Obtener las visitas y el estado actual del mapa
      const visits = this.routes.flatMap((route) => route.visits);
      const mapState = this.getMapState(); // Aquí debes tener un método para obtener el estado actual del mapa

      // Crear el contenido HTML para el mapa dentro del popup
      popup.document.write(`
        <html>
          <head>
            <title>Mapa</title>
            <link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />
          </head>
          <body style="margin: 0; height: 100vh;">
            <div id="map" style="height: 100%;"></div>
            <script src="https://unpkg.com/leaflet/dist/leaflet.js"></script>
            <script>
              const map = L.map('map').setView([${mapState.lat}, ${mapState.lng}], ${mapState.zoom});
              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                maxZoom: 19
              }).addTo(map);

              // Agregar los puntos de las visitas al mapa
              const visits = ${JSON.stringify(visits)};
              visits.forEach(visit => {
                L.marker([visit.geoPoint[0], visit.geoPoint[1]])
                  .addTo(map)
                  .bindPopup(visit.name); // Aquí asumiendo que cada visita tiene una propiedad 'name'
              });

         // Método para restaurar el mapa cuando se cierra el popup
            window.addEventListener('unload', () => {
              if (window.opener && typeof window.opener.restoreMap === "function") {
                window.opener.restoreMap();  // Llamamos al método restoreMap en el componente principal
              }
            });

            // Escucha el evento de cierre del popup
            window.addEventListener('unload', closePopupListener);

            // Si el popup se cierra de otra manera, intentamos restaurar el mapa
            window.onbeforeunload = closePopupListener;
            </script>
          </body>
        </html>
      `);
      popup.document.close();
    }
  }

  // Método para restaurar el mapa cuando se cierra el popup
  restoreMap() {
    this.showMap = true; // Mostrar nuevamente el mapa en el componente principal
  }

  // Método para obtener el estado actual del mapa
  getMapState() {
    // Suponiendo que tu componente `app-agenda-map` tiene el mapa inicializado
    const map = this.mapComponent.getMapInstance(); // Método que deberías crear en tu componente hijo
    const center = map.getCenter();
    const zoom = map.getZoom();

    return {
      lat: center.lat,
      lng: center.lng,
      zoom: zoom,
    };
  }

  // groupOrders(data): any {
  //   let groupedDataSource = data.reduce((result, item) => {
  //     const key = `${item.shipTo.externalKeys.code}|${item.trip.id}|`;

  //     if (!result[key]) {
  //       result[key] = {
  //         identifier: key,
  //         id: item.id || item.code,
  //         shipTo: item.shipTo,
  //         subTotal: 0,
  //         documents: 0,
  //         loan: 0,
  //         weightUnitOfMeasureCode: 'LB',
  //         detail: [],
  //       };
  //     }

  //     const company = this.companyList.find((company) => company.id === item.company.id);

  //     const loadCalculationMode = company && company.loadCalculationMode
  //       ? company.loadCalculationMode
  //       : LoadCalculationModeEnum.BY_DIMENSIONS;

  //     if (item.detail) {
  //       let weightUnitOfMeasureCodeHeader = 'LB';
  //       const enrichedDetail = item.detail.map(detailItem => {
  //         let loan = 0;
  //         let weightUnitOfMeasureCode = 'LB';
  //         let price = 0;

  //         price = detailItem.originalUnitPrice * detailItem.soldQuantity;

  //         if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
  //           if (detailItem.material && detailItem.material.dimensions) {
  //             const grossWeight = detailItem.material.dimensions.grossWeight || 0;
  //             const baseQuantity = detailItem.material.baseQuantity || 0;
  //             weightUnitOfMeasureCode = detailItem.material.dimensions.weightUnitOfMeasureCode || 'LB';
  //             weightUnitOfMeasureCodeHeader = weightUnitOfMeasureCode;
  //            loan = grossWeight * baseQuantity;
  //           }
  //         } else if (loadCalculationMode === LoadCalculationModeEnum.BY_BASE_QUANTITY) {
  //          if (detailItem) {
  //             const baseQuantity = detailItem.baseQuantity || 0;
  //             weightUnitOfMeasureCode = detailItem.baseUnitOfMeasure?.code || 'LB';
  //             weightUnitOfMeasureCodeHeader = weightUnitOfMeasureCode;
  //             loan = baseQuantity;
  //           }
  //         }

  //           return {
  //           ...detailItem,
  //           type: item.type.name,
  //           price:price,
  //           serial: item.serial,
  //           loan: loan,
  //           weightUnitOfMeasureCode: weightUnitOfMeasureCode,
  //           };
  //       });

  //       result[key].detail.push(...enrichedDetail);

  //       const groupLoan = enrichedDetail.reduce((sum, detailItem) => sum + detailItem.loan, 0);
  //       result[key].loan += groupLoan;
  //       result[key].weightUnitOfMeasureCode = weightUnitOfMeasureCodeHeader;
  //     }

  //     if (item.id) {
  //       result[key].detail.push({
  //         material: { name: '' },
  //         originalUnitPrice: 0,
  //         loan: 0.00,
  //         type: 'VISITA',
  //         serial: item?.serials || 'Estableci'
  //       });
  //     }

  //     // Si el item tiene tipo, incrementar el contador de documentos
  //     if (item.type) {
  //       result[key].documents += 1;
  //     }

  //     result[key].subTotal += item.subTotal || 0;

  //     return result;
  //   }, {});

  //   let dataSource = Object.values(groupedDataSource);
  //   return dataSource;
  // }

  groupOrders(data): any {
    let groupedDataSource = data.reduce((result, item) => {
      const key = `${item.shipTo.externalKeys.code}|${item.trip.id}|`;

      if (!result[key]) {
        result[key] = {
          identifier: key,
          id: item.id || item.code,
          shipTo: item.shipTo,
          documentDetails: [],
          ordersByTypeAndSerial: [],
        };
      }

      const documentTypeKey = item.type.code;
      const serialKey = item.serial;

      let typeAndSerialGroup = result[key].ordersByTypeAndSerial.find(
        (group) =>
          group.type.code === documentTypeKey && group.serial === serialKey
      );

      if (!typeAndSerialGroup) {
        typeAndSerialGroup = {
          type: item.type,
          class: item.class,
          serial: item.serial,
          statusERP: item.statusERP,
          statusId: item.statusId,
          loan: 0,
          total: 0,
          weightUnitOfMeasureCode: "LB",
          items: [],
        };
        result[key].ordersByTypeAndSerial.push(typeAndSerialGroup);
      }

      typeAndSerialGroup.items.push(item.detail);

      const company = this.companyList.find(
        (company) => company.id === item.company.id
      );

      const loadCalculationMode =
        company && company.loadCalculationMode
          ? company.loadCalculationMode
          : LoadCalculationModeEnum.BY_DIMENSIONS;

      const enrichedDetail = item.detail.map((detailItem) => {
        let loan = 0;
        let price = 0;
        let weightUnitOfMeasureCode = "LB";

        price = detailItem.originalUnitPrice * detailItem.soldQuantity;

        if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
          if (detailItem.material && detailItem.material.dimensions) {
            const grossWeight = detailItem.material.dimensions.grossWeight || 0;
            const baseQuantity = detailItem.material.baseQuantity || 0;
            weightUnitOfMeasureCode =
              detailItem.material.dimensions.weightUnitOfMeasureCode || "LB";
            loan = grossWeight * baseQuantity;
          }
        } else if (
          loadCalculationMode === LoadCalculationModeEnum.BY_BASE_QUANTITY
        ) {
          if (detailItem) {
            const baseQuantity = detailItem.baseQuantity || 0;
            weightUnitOfMeasureCode =
              detailItem.baseUnitOfMeasure?.code || "LB";
            loan = baseQuantity;
          }
        }

        return {
          ...detailItem,
          type: item.type.name,
          price: price,
          loan: loan,
          weightUnitOfMeasureCode: weightUnitOfMeasureCode,
        };
      });
      typeAndSerialGroup.items.push(...enrichedDetail);

      const groupLoan = enrichedDetail.reduce(
        (sum, detailItem) => sum + detailItem.loan,
        0
      );
      typeAndSerialGroup.loan += groupLoan;

      const groupTotal = enrichedDetail.reduce(
        (sum, detailItem) => sum + detailItem.price,
        0
      );
      typeAndSerialGroup.total += groupTotal;

      result[key].subTotal += groupTotal;

      // Actualizamos la unidad de medida del peso
      // result[key].weightUnitOfMeasureCode = weightUnitOfMeasureCode;

      // Almacenar los documentos para el conteo en la siguiente línea
      if (item.type) {
        result[key].documentDetails.push(item); // Agregar el item al arreglo de documentos
      }

      // if (item.id) {
      //   result[key].detail.push({
      //     material: { name: '' },
      //     originalUnitPrice: 0,
      //     loan: 0.00,
      //     type: 'VISITA',
      //     serial: item?.serials || 'Estableci'
      //   });
      // }

      // // Si el item tiene tipo, incrementar el contador de documentos
      // if (item.type) {
      //   result[key].documents += 1;
      // }

      result[key].subTotal += item.subTotal || 0;

      return result;
    }, {});

    // Después de agrupar, llamar a calculateStatusGroup con los documentos del grupo
    let dataSource = Object.values(groupedDataSource).map((group: any) => {
      const documents = group.documentDetails; // Obtener todos los documentos del grupo
      group.document = this.calculateStatus(documents); // Pasar todos los documentos al cálculo
      return group;
    });

    return dataSource;
  }
  public onDetailsDocument() {
    this.isVisibleDetailsDoc = !this.isVisibleDetailsDoc;
  }

  // Calculo para las metricas generales de documentos
  private calculateStatus(documents: any[]): statusDocument {
    var countDocument = 0;
    var notAllowedSync = 0;
    var notSynchronization = 0;
    var loadSynchronization = 0;
    var synchronization = 0;
    documents.forEach((doc) => {
      countDocument++;
      if (doc.statusERP === undefined) {
        notAllowedSync++;
      } else if ([OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR].includes(doc.statusERP)) {
        notSynchronization++;
      } else if ([OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND].includes(doc.statusERP)) {
        loadSynchronization++;
      } else if (doc.statusERP === OrderStatusERPEnum.ORDER_CREATED) {
        synchronization++;
      }
    });

    return {
      countDocument,
      notAllowedSync,
      notSynchronization,
      loadSynchronization,
      synchronization,
    };
  }

  selectVisit(visit: any) {
    if (Array.isArray(visit)) {
      this.selectedVisits = visit;
    } else {
      this.selectedVisits = [visit];
    }
  }

  async loadDataVisit(dataSelect, route) {
   try {
     const pageSize = 100;
     const currentPage = 1;
     const sortField = "dateTimeStart";
     const tripId = dataSelect
     const data = await this.findAllWithCountByTripMonitor(
       pageSize,
       currentPage,
       sortField,
       tripId
     );
     /*this.dataSourceItemsRoutes = data[0].data;
     this.dataSourceItemsRoutes = this.calculateTimeVisit(
       this.dataSourceItemsRoutes
     );*/
     //this.routes = data[0].data;
     /*this.dataSourceItemsRoutes = data[0].data;*/
     /*route.visits = data[0].data;
     route.visits = this.calculateTimeVisit(
       this.dataSourceItemsRoutes
     );*/

     let visitsAux = data[0].data;
     visitsAux = this.calculateTimeVisit(
       visitsAux
     );

     this.selectedVisits = visitsAux;

     this.dataSourceVisit = new MatTableDataSource(visitsAux);

     this.statusRoute = this.calculateVisitValid(this.dataSourceItemsRoutes);
   } catch (error) {
     this.snackBar.open(error.error.message || "Error al cargar visitas.","Cerrar",{ duration: 5000});
   }
 }

 private async findAllWithCountByTripMonitor(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number
  ): Promise<any> {
    const sortDirection = "ASC";

    try {
      const response = await this.visitService
        .findAllWithCountByTripMonitor(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            //search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId
        )
        .toPromise();
      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtenervisitas.","Cerrar",{ duration: 5000});
      throw error;
    }
  }

  private calculateTimeVisit(visits: VisitAttributes[]) {
    return visits?.map((route: VisitAttributes) => {
      if (route?.dateTimeStart && route?.dateTimeEnd) {
        const start = new Date(route.dateTimeStart);
        const end = new Date(route.dateTimeEnd);
        const duration = end.getTime() - start.getTime();
        const hours = Math.floor(duration / (1000 * 60 * 60));
        const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((duration % (1000 * 60)) / 1000);

        return {
          ...route,
          duration: `${hours
            .toString()
            .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
              .toString()
              .padStart(2, "0")}`,
        };
      }

      return route;
    });
  }

  private calculateVisitValid(visits: VisitAttributes[]): IStatusRoute {
    var visitValid = 0;
    var visitNotValid = 0;
    var countDocument = 0;
    visits?.forEach((visit) => {
      countDocument++;
      if (visit?.validVisit) {
        visitValid++;
      } else {
        visitNotValid++;
      }
    });

    return {
      countDocument,
      visitValid,
      visitNotValid,
    };
  }

  view(route){
  }

}
